// extracted by mini-css-extract-plugin
export default {"box":"none_box__gDtCK"};